module.exports = __webpack_public_path__ + "static/img/8.dbd5367.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/8.jpg
// module id = BVNo
// module chunks = 1